module.exports = __webpack_public_path__ + "assets/img/season5-01bea7bc.png";